// src/services/tmdbService.ts

const TMDB_API_KEY = "bd94a1b0354e2306b60de4a33422910e";

export async function fetchTmdbMovieDetails(tmdbId: string | number) {
  if (!tmdbId) return { cast: [], runtime: 0, release_date: null };

  try {
    const response = await fetch(
      `https://api.themoviedb.org/3/movie/${tmdbId}?api_key=${TMDB_API_KEY}&language=pt-BR&append_to_response=credits,release_dates`
    );
    const data = await response.json();

    // 1. Processa o elenco principal (limita aos 10 primeiros)
    const cast = data.credits && data.credits.cast ? data.credits.cast.slice(0, 10) : [];

    // 2. Descobre a data de lançamento focada no Brasil (BR)
    let finalReleaseDate = data.release_date;
    if (data.release_dates && data.release_dates.results) {
      const brObj = data.release_dates.results.find((r: any) => r.iso_3166_1 === 'BR');
      if (brObj && brObj.release_dates && brObj.release_dates.length > 0) {
        const sortedDates = brObj.release_dates.sort(
          (a: any, b: any) => new Date(a.release_date).getTime() - new Date(b.release_date).getTime()
        );
        finalReleaseDate = sortedDates[0].release_date;
      }
    }

    return {
      cast,
      runtime: data.runtime || 0,
      release_date: finalReleaseDate
    };
  } catch (err) {
    console.error("Erro ao buscar dados unificados do TMDB:", err);
    return { cast: [], runtime: 0, release_date: null };
  }
}